import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import ReactTooltip from 'react-tooltip';
import { useMediaQuery } from 'react-responsive';
import bp from '../../../config/breakpoints';
import AgentConversationCardStyled from './styled';
import { ChatCellInfo, VisibilityIcon, IconButton, TransferConvIcon, CloseConvIcon, WhatsappIcon, WebchatIcon, MessengerIcon } from '../../atoms';
import i18n from '../../../assets/i18n';
import TagsBox from "../tags-box";


const AgentConversationCard = ({ data, hideSeeButton, onSeeConversationClick, onCloseConversationClick, onTransferConversationClick }) => {
  const isMediumScreen = useMediaQuery({ query: `(max-width: ${bp.md}px)` });
  const { conversationSessionId, profileName, lastMessageReceived, lastMessageSent } = data;
  const [timeAgoLastMessageReceived, setTimeAgoLastMessageReceived] = useState('');
  const [timeAgoLastMessageSent, setTimeAgoLastMessageSet] = useState('');
  const [lastMessageRecievedISOString, setLastMessageRecievedISOString] = useState('');
  const [lastMessageSentISOString, setLastMessageSentISOString] = useState('');
  const [channelIcon, setChannelIcon] = useState(null);

  const updateTimeInterval = 60 * 1000;

  useEffect(() => {
    setTimeAgoLastMessageReceived(moment(lastMessageReceived).fromNow());
    setTimeAgoLastMessageSet(moment(lastMessageSent).fromNow());
    setLastMessageRecievedISOString(lastMessageReceived);
    setLastMessageSentISOString(lastMessageSent);

    const interval = setInterval(() => {
      setTimeAgoLastMessageReceived(moment(lastMessageRecievedISOString).fromNow());
      setTimeAgoLastMessageSet(moment(lastMessageSentISOString).fromNow());
    }, updateTimeInterval);

    return () => clearInterval(interval);
  }, [lastMessageReceived, lastMessageSent, lastMessageRecievedISOString, lastMessageSentISOString, updateTimeInterval]);

  useEffect(() => {
    if (data.channel === 'whatsapp') {
      setChannelIcon(
        <div data-tip={i18n.chats.whatsapp} data-place="left" data-tip-disable={isMediumScreen}>
          <WhatsappIcon className="agent-conversation-card--channel-icon-holder--icon" />
        </div>
      );
    } else if (data.channel === 'messenger') {
      setChannelIcon(
        <div data-tip={i18n.chats.messenger} data-place="left" data-tip-disable={isMediumScreen}>
          <MessengerIcon className="agent-conversation-card--channel-icon-holder--icon" />
        </div>
      );
    } else {
      setChannelIcon(
        <div data-tip={i18n.chats.webchat} data-place="left" data-offset="{'left': 10}" data-tip-disable={isMediumScreen}>
          <WebchatIcon className="agent-conversation-card--channel-icon-holder--icon" />
        </div>
      );
    }
  }, [data.channel, isMediumScreen]);


  const isContactId = data && data.contactId && (data.channel === 'whatsapp' || data.channel === 'cloudapi');
  let chatLabel;
  if (isContactId) {
      chatLabel = `+${data.contactId}`;
  } else if (data && data.contactId) {
      chatLabel = `#${data.contactId}`;
  } else {
      chatLabel = `${i18n.chats.singleConversation} #${data.conversationSessionId}`;
  }


  return (
    <>
      <AgentConversationCardStyled>
        <div className="agent-conversation-card--info">
          {/* <UserIcon fill="#CECECE" /> */}
          <div className="agent-converstation-card--info--text">
            <ChatCellInfo row title={`${i18n.chats.singleConversation} ${chatLabel}`} profileName={profileName} />
            {lastMessageReceived && (
              <p className="agent-converstation-card--info--text--subtitle">
                {i18n.supervisor.lastMessageReceived} {timeAgoLastMessageReceived}
              </p>
            )}
            {lastMessageSent && (
              <p className="agent-converstation-card--info--text--subtitle">
                {i18n.supervisor.lastMessageSent} {timeAgoLastMessageSent}
              </p>
            )}
          </div>
        </div>
          {data?.topics?.length ? <TagsBox tags={data?.topics} isManager /> : <div/> }
        <div className="agent-conversation-card--channel-icon-holder">{channelIcon}</div>
        <div className="agent-conversation-card--buttons-row">
          {!hideSeeButton && (
            <IconButton
              toolTip={i18n.supervisor.seeMessages}
              disableToolTip={isMediumScreen}
              onClick={(e) => {
                e.preventDefault();
                onSeeConversationClick(conversationSessionId);
              }}
            >
              <VisibilityIcon className="button-icon ts ts-normal" />
            </IconButton>
          )}
          <IconButton
            toolTip={i18n.chats.transferConvToolTip}
            disableToolTip={isMediumScreen}
            onClick={() => onTransferConversationClick(conversationSessionId)}
          >
            <TransferConvIcon className="button-icon ts ts-normal" />
          </IconButton>
          <IconButton toolTip={i18n.chats.endconvToolTip} disableToolTip={isMediumScreen} onClick={() => onCloseConversationClick(conversationSessionId)}>
            <CloseConvIcon className="button-icon ts ts-normal" />
          </IconButton>
        </div>
      </AgentConversationCardStyled>
      <ReactTooltip type="info" />
    </>
  );
};

AgentConversationCard.propTypes = {
  data: PropTypes.object.isRequired,
  onSeeConversationClick: PropTypes.func,
  onCloseConversationClick: PropTypes.func,
  onTransferConversationClick: PropTypes.func,
  hideSeeButton: PropTypes.bool,
};

export default AgentConversationCard;
